import { reactToCwp } from '../../../../common/react-utils'
import { MilestoneHighlight } from './MilestoneHighlight'

export default reactToCwp(MilestoneHighlight)
